@if (variant === 'h3') {
    <h3 [ngStyle]="style">
        <ng-container *ngTemplateOutlet="content" />
    </h3>
}

@if (variant === 'medium-text') {
    <h6 [ngStyle]="style">
        <ng-container *ngTemplateOutlet="content" />
    </h6>
}

@if (variant === 'detail-text') {
    <p [ngStyle]="style">
        <ng-container *ngTemplateOutlet="content" />
    </p>
}

<ng-template #content>
    <ng-content />
</ng-template>
